import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { LANGUAGES } from "@/i18n";

export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "en").split("-")[0];
  const change = (e) => i18n.changeLanguage(e.target.value);
  return (
    <div className={`relative inline-flex items-center ${className}`} data-testid="language-switcher">
      <Globe size={15} className="absolute left-2.5 pointer-events-none text-[#94A3B8]" />
      <select
        value={LANGUAGES.some((l) => l.code === current) ? current : "en"}
        onChange={change}
        aria-label="Language"
        data-testid="language-select"
        className="appearance-none bg-[#111C30] border border-[#1E293B] text-[#E2E8F0] text-sm rounded-md pl-8 pr-7 py-1.5 hover:border-[#00BFFF] focus:border-[#00BFFF] outline-none cursor-pointer transition-colors"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} className="bg-[#0B111D]">{l.label}</option>
        ))}
      </select>
    </div>
  );
}
